<template>
  <div class="web-003-flooter">
    <div class="copyright">
      {{ websiteMsg.copyright }}
    </div>
    <div>
      {{ websiteMsg.icpFilingCode }}
      <span v-if="websiteMsg.policeFilingCode">{{ websiteMsg.policeFilingCode }}</span>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Flooter',
    props: {
        websiteMsg: {
            type: Object,
            default: () => {},
        },
    },
};
</script>

<style scoped lang="scss">
@import "../style.scss";
.web-003-flooter {
    width: 100%;
    height: 120px;
    background-color: #32343A;
    color: #FFFFFF;
    font-size: 14px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    box-sizing: border-box;
    padding: 0 40px;
    .copyright {
        margin-bottom: 10px;
    }
    span {
        margin-left: 10px;
    }
}
</style>
